import { Controller } from "@hotwired/stimulus"

// Click-to-load YouTube facade. Shows a static thumbnail + play button until
// clicked, then swaps in the real (auto-playing) iframe. Keeps the page light
// and avoids loading YouTube until the visitor actually wants it.
export default class extends Controller {
	static values = { id: String }

	load() {
		const iframe = document.createElement("iframe")
		iframe.src = `https://www.youtube-nocookie.com/embed/${this.idValue}?autoplay=1&rel=0`
		iframe.title = "Product walkthrough"
		iframe.allow = "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
		iframe.allowFullscreen = true
		iframe.className = "absolute inset-0 h-full w-full rounded-xl"

		this.element.innerHTML = ""
		this.element.appendChild(iframe)
	}
}
